module.exports = __webpack_public_path__ + "css/theme/dark.css";


//////////////////
// WEBPACK FOOTER
// ./plugins/Admin/build/style/theme/dark.css
// module id = 62
// module chunks = 0